import React, { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";

import { Header, Input, Grid, Button, Form, Label, DropdownProps, Segment, InputOnChangeData, Modal } from "semantic-ui-react";

import TableApp, { ITableAppRender } from "../../components/TableApp";
import MaskedInput from "../../components/MaskedInput";
import { GetUser } from "../../services/auth";

import { IKit, IItemKit, IConference } from "../../interfaces";
import KitRepository from "../../Repositories/KitRepository";
import ItemKitRepository from "../../Repositories/ItemKitRepository";
import ProdutoRepository, { IProdutoListModel } from "../../Repositories/ProdutoRepository";
import ConferenceRepository from "../../Repositories/ConferenceRepository";

import NumberFormat from "../../Utils/NumberFormat";
import errors from "../../Utils/ExtractErrors";
import { RouteComponentProps } from "react-router-dom";
import { format } from "date-fns";
import ModalYesNo from "../../components/ModalYesNo";
import TemplateMain from "../../components/TemplateMain";
import CustomLoader from "../../components/CustomLoader";
import ModalApp from "../../components/ModalApp";

interface IItemKitEdit extends IItemKit {
    isNew: boolean;
}

interface IItemModel extends IItemKitEdit {
    item: number;
    codigo: string | undefined;
    descricao: string | undefined;
}

interface State extends IKit {

}

interface StateConference extends IConference {

}

interface Props {
    id: string;
}

const initialStateConference: StateConference = {
    comissaoGerente: 0,
    comissaoRepresentante: 0,
    comissaoRevendedor: 0,
    conferedBy: "",
    conferenceType: 0,
    data: "",
    id: "",
    kitId: "",
    valorRecebido: 0,
    valorVendido: 0,
    valorCorrigido: 0
}

const initialState: State = {
    id: "",
    data: "",
    numero: 0,
    valor: 0,
    statusKit: 0,
    pedidoId: "",
    revendedorId: "",
    prorrogado: 0,
    liberacao: 0,
    nomeOperador: ""
}

const GerenciarKit: React.FC<RouteComponentProps<Props>> = ({ match, location }) => {

    const [open, setOpen] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [saving, setSaving] = useState<boolean>(false);
    const [produtos, setProdutos] = useState<IProdutoListModel[]>([]);
    const [codigo, setCodigo] = useState<string>("");

    const [conference, setConference] = useState<StateConference>(initialStateConference);
    const [valorRecebido, setValorRecebido] = useState<string>("");
    const [valorCorrigido, setValorCorrigido] = useState<string>("");
    const [state, setState] = useState<State>(initialState);
    const [items, setItems] = useState<IItemKitEdit[]>([]);
    const [tableList, setTablelist] = useState<IItemModel[]>([]);

    const valorReceber = parseFloat(valorCorrigido.replace("R$", "").replace(".", "").replace(",", ".")) > 0
        ? parseFloat(valorCorrigido.replace("R$", "").replace(".", "").replace(",", "."))
        : conference.valorVendido - conference.comissaoRevendedor;
    const valorDebito = conference.valorCorrigido > 0
        ? parseFloat(valorRecebido.replace("R$", "").replace(".", "").replace(",", ".")) - conference.valorCorrigido
        : parseFloat(valorRecebido.replace("R$", "").replace(".", "").replace(",", ".")) - valorReceber;

    const { role } = GetUser();


    const LoadKit = useCallback(async () => {
        setLoading(true);
        try {
            const [kit, items, produtos, conference] = await Promise.all([
                KitRepository.GetById(match.params.id),
                ItemKitRepository.ListByKitId(match.params.id),
                ProdutoRepository.List({ filter: "STATUS == 1" }),
                ConferenceRepository.GetConferenceByKitId(match.params.id)
            ]);

            setState(kit);

            const kitItems = items as IItemKitEdit[];

            setItems(kitItems);
            setProdutos(produtos.list);
            setConference(conference);
            setValorRecebido(NumberFormat.Currency(conference.valorRecebido));
            setValorCorrigido(NumberFormat.Currency(conference.valorCorrigido));

        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
        setLoading(false);
    }, [match.params.id]);

    useEffect(() => { LoadKit(); }, [LoadKit]);


    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCodigo(e.target.value);
    }

    const handleOnChangeValorCorrigido = (event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
        setValorCorrigido(data.value);
    }

    const handleOnChangeValorRecebido = (event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
        setValorRecebido(data.value);
    }

    const handleAddItem = () => {
        const item = produtos.find(x => x.codigo.toUpperCase() === codigo.toUpperCase());

        if (item !== undefined) {
            setCodigo("");
            setItems([{
                isNew: true,
                quantidade: 1,
                statusItemKit: 0,
                kitId: match.params.id,
                produtoId: item.id,
                valor: item.valor
            },
            ...items
            ]);
        }
        else {
            toast("Produto não encontrado", { position: "top-center", type: "error" });
        }
    }

    const handleRemoveItem = (index: number) => {
        const item = items.find((x, i) => i === index);

        if (item !== undefined) {
            const newItems = items.filter((x, i) => i !== index);

            setItems(newItems);
        }
    }

    const isDisabled = role !== "Admin";
    const isAlterable = state.statusKit == 0;

    const removeButton = (index: number, isNew: boolean) =>
        <Button
            icon="trash"
            color="orange"
            onClick={() => handleRemoveItem(index)}
        />

    const removeItemKit = async (id: string) => {
        try {
            await ItemKitRepository.Delete(id);
            LoadKit();
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
    }

    const optionStatusKit = [
        { key: "0", text: "ESTOCADO", value: 0, icon: "box" },
        { key: "1", text: "G. SETOR", value: 1, icon: "user" },
        { key: "2", text: "REPRESENTANTE", value: 2, icon: "id badge" },
        { key: "3", text: "REVENDEDOR", value: 3, icon: "street view" },
        { key: "4", text: "PRÉ-CONFERIDO", value: 4, icon: "stopwatch" },
        { key: "5", text: "CONF. ERRADO", value: 5, icon: "thumbs down outlined" },
        { key: "6", text: "CONF. GERENTE SETOR", value: 6, icon: "thumbs up outline" },
        { key: "7", text: "CONF. GERENTE REGIONAL", value: 7, icon: "handshake" },
        { key: "8", text: "FINALIZADO", value: 8, icon: "check" }
    ];

    const optionLiberacao = [
        { key: "0", text: "NORMAL", value: 0, icon: "thumbs up outline" },
        { key: "1", text: "AGUARDANDO LIBERAÇÃO", value: 1, icon: "clock" },
        { key: "2", text: "LIBERADO", value: 2, icon: "thumbs up" },
        { key: "3", text: "NÃO LIBERADO", value: 3, icon: "dont" },
    ];

    const optionEstado = [
        { key: "0", text: "NORMAL", value: 0, icon: "thumbs up outline" },
        { key: "1", text: "DEVEDOR", value: 1, icon: "user times" },
        { key: "2", text: "NÃO RETORNOU", value: 2, icon: "thumbs down" }
    ];

    const optionTipo = [
        { key: "0", text: "NOVO", value: 0, icon: "hand point up outline" },
        { key: "1", text: "ACERTO", value: 1, icon: "hand peace outline" }
    ];

    const onDropdownChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        const { name, value } = data;
        setState(state => ({ ...state, [name]: value }));
    }

    const handleTableData = useCallback(() => {

        let data: IItemModel[] = [];
        let contador: number = items.length;

        items.map((itemkit) => {
            return data.push({
                item: contador--,
                ...itemkit,
                codigo: produtos.find(produto => produto.id === itemkit.produtoId)?.codigo,
                descricao: produtos.find(produto => produto.id === itemkit.produtoId)?.nome
            });
        });

        setTablelist(data);
    }, [items, produtos]);

    const handleOpen = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    }

    const handleFinalizar = async () => {
        setSaving(true);
        try {

            const itemsToUpdate = items.filter(item => item.isNew === true);

            const [kitUpdate, itemKitUpdate] = await Promise.all([
                KitRepository.Update({
                    id: match.params.id,
                    kitPutModel: {
                        revendedorId: state.revendedorId || "",
                        statusKit: state.statusKit,
                        estado: state.estado,
                        tipo: state.tipo,
                        liberacao: state.liberacao,
                        valor: items.reduce((accumulator: number, item: IItemKitEdit) => {
                            return accumulator += item.valor;
                        }, 0).toString()
                    }
                }),
                itemsToUpdate.length > 0 ? ItemKitRepository.InsertRange(itemsToUpdate) : undefined
            ]);

            toast(kitUpdate.data.message, { position: "top-center", type: "success" });

            if (itemKitUpdate) {
                toast(itemKitUpdate.message, { position: "top-center", type: "success" });
            }

            LoadKit();

        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
        setSaving(false);
    }

    const handleValores = async () => {

        if (valorRecebido.length <= 0) {
            return toast("O valor recebido é obrigatório.", { position: "top-center", type: "error" });
        }
        const valor = parseFloat(valorRecebido.replace(".", "").replace(",", "."));
        if (valor > valorReceber) {
            return toast("O valor recebido não pode ser maior que o valor à receber.", { position: "top-center", type: "error" });
        }
        setSaving(true);
        try {

            const response = await ConferenceRepository.UpdateConference({
                id: match.params.id,
                conferencePutModel: {
                    valorRecebido: valor
                }
            });

            toast(response.data.message, { position: "top-center", type: "success" });
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
        setSaving(false);
        LoadKit();
    }

    const handleValorCorrigido = async () => {

        const vCorrigido = parseFloat(valorCorrigido.replace(".", "").replace(",", "."));
        setSaving(true);
        try {

            const response = await ConferenceRepository.UpdateValorCorrigido({
                id: match.params.id,
                corrigidoPutModel: {
                    valorCorrigido: vCorrigido
                }
            })

            toast(response.data.message, { position: "top-center", type: "success" });
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
        setOpen(false);
        setSaving(false);
        LoadKit();
    }


    const setSituacao = (statusItemKit: number) => {
        switch (statusItemKit) {
            case 0:
                return <Label icon="street view" color="grey" size="small" content="RUA" />
            case 1:
                return <Label icon="history" color="yellow" size="small" content="RET" />
            case 2:
                return <Label icon="thumbs up" color="green" size="small" content="VEN" />
            case 3:
                return <Label icon="thumbs down" color="black" size="small" content="NRT" />
            default:
                break;
        }
    }


    // INICIO MODAL
    const valorReajustado = (
        <Modal.Content scrolling>
            {loading &&
                <CustomLoader />}
            {!loading &&
                <>
                    <Grid.Column>
                        <Form>
                            <Grid.Row>
                                <Header>Insira o valor reajustado com o juros</Header>
                                <Grid.Column>
                                    <Form.Group widths="equal">
                                        <Form.Field>
                                            <label>Valor Corrigido</label>
                                            <MaskedInput
                                                fluid
                                                mask="currency"
                                                label={"R$"}
                                                value={valorCorrigido.replace("R$", "") || 0}
                                                onChange={handleOnChangeValorCorrigido}
                                            />
                                        </Form.Field>
                                    </Form.Group>
                                </Grid.Column>
                            </Grid.Row>
                        </Form>
                    </Grid.Column>
                </>
            }
        </Modal.Content >
    );

    // FIM MODAL
    useEffect(() => { handleTableData() }, [handleTableData, items]);

    const tableRender: ITableAppRender[] = [
        {
            header: "Item",
            content: (x: IItemModel) => x.item,
            textAlign: "center",
            width: 1
        },
        {
            header: "Código",
            content: (x: IItemModel) => x.codigo,
            textAlign: "center",
            width: 2
        },
        {
            header: "Descrição",
            content: (x: IItemModel) => x.descricao,
            width: 9
        },
        {
            header: "Valor",
            content: (x: IItemModel) => NumberFormat.Currency(x.valor),
            textAlign: "center",
            width: 1
        },
        {
            header: "Situação",
            content: (x: IItemModel) => setSituacao(x.statusItemKit),
            width: 1
        },
    ];

    const content = (
        <Grid columns="equal">
            {
                state.nomeOperador ?
                    <Grid.Row>
                        <Grid.Column>
                            <Header
                                floated="left"
                                size="tiny"
                                content={`${state.nomeOperador}`}
                                icon="user circle"
                            />
                            <Header
                                floated="right"
                                size="tiny"
                                content={`${state.data ? format(new Date(state.data), "HH:mm:ss") : ""}`}
                                icon="clock"
                            />
                            <Header
                                floated="right"
                                size="tiny"
                                content={`${state.data ? format(new Date(state.data), "dd/MM/yyyy") : ""}`}
                                icon="calendar alternate"
                            />
                        </Grid.Column>
                    </Grid.Row>
                    : ""
            }
            <Grid.Row>
                <Grid.Column>
                    <Header size="huge" content={`KIT: ${state.numero}`} icon="box" />
                </Grid.Column>
                {
                    location.state.acerto &&
                    <Grid.Column>
                        <Button
                            floated="right"
                            color={state.statusKit == 8 || state.statusKit == 5 ? "grey" : "blue"}
                            content={`DATA DE ACERTO: ${format(new Date(location.state.acerto), "dd/MM/yyyy")}`}
                        />
                    </Grid.Column>
                }
            </Grid.Row>
            <Grid.Row>
                <Grid.Column>
                    <Segment secondary color="pink">
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <Form.Input
                                        fluid
                                        readOnly
                                        label="G. Setor"
                                        placeholder="Indefinido"
                                        value={location.state.gerenteSetor}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <Form.Input
                                        fluid
                                        readOnly
                                        label="Representante"
                                        placeholder="Indefinido"
                                        value={location.state.representante}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <Form.Input
                                        fluid
                                        readOnly
                                        label="Revendedor"
                                        placeholder="Indefinido"
                                        value={location.state.revendedor}
                                    />
                                </Form.Field>
                            </Form.Group>
                            {
                                role === "Admin" &&
                                <Form.Group widths="equal">
                                    <Form.Field>
                                        <Form.Dropdown
                                            fluid
                                            selection
                                            scrolling
                                            name="statusKit"
                                            label="Status"
                                            options={optionStatusKit}
                                            value={state.statusKit}
                                            onChange={onDropdownChange}
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <Form.Dropdown
                                            fluid
                                            selection
                                            scrolling
                                            name="liberacao"
                                            label="Liberação"
                                            options={optionLiberacao}
                                            value={state.liberacao}
                                            onChange={onDropdownChange}
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <Form.Dropdown
                                            fluid
                                            selection
                                            scrolling
                                            name="estado"
                                            label="Estado"
                                            options={optionEstado}
                                            value={state.estado}
                                            onChange={onDropdownChange}
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <Form.Dropdown
                                            fluid
                                            selection
                                            scrolling
                                            name="tipo"
                                            label="Tipo"
                                            options={optionTipo}
                                            value={state.tipo}
                                            onChange={onDropdownChange}
                                        />
                                    </Form.Field>
                                </Form.Group>
                            }
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <Input
                                        fluid
                                        label="Inserir produtos"
                                        placeholder="Insira o código do produto"
                                        onChange={handleOnChange}
                                        value={codigo}
                                        action={{ icon: "add", color: "pink", onClick: handleAddItem, disabled: !isAlterable }}
                                        disabled={!isAlterable}
                                    />
                                </Form.Field>
                                <Form.Field width="16">
                                    <Button
                                        fluid
                                        icon="check"
                                        color="pink"
                                        content="Salvar Kit"
                                        loading={saving}
                                        onClick={handleFinalizar}
                                    />
                                </Form.Field>
                            </Form.Group>
                        </Form>
                    </Segment>
                </Grid.Column>
            </Grid.Row>
            {
                state.statusKit >= 4 && conference.valorVendido > 0 &&
                <Grid.Row>
                    <Grid.Column>
                        <Segment color="pink">
                            <Form>
                                <Form.Group widths="equal">
                                    <Form.Field>
                                        <Form.Input
                                            fluid
                                            readOnly
                                            label="R$ VENDIDO"
                                            value={NumberFormat.Currency(conference.valorVendido || 0)}
                                        />
                                    </Form.Field>
                                    {
                                        conference.valorCorrigido > 0 &&
                                        <Form.Field>
                                            <Form.Input
                                                fluid
                                                readOnly
                                                label="R$ CORRIGIDO"
                                                value={NumberFormat.Currency(conference.valorCorrigido || 0)}
                                            />
                                        </Form.Field>
                                    }
                                </Form.Group>
                                <Form.Group widths="equal">
                                    <Form.Field>
                                        <Form.Input
                                            fluid
                                            readOnly
                                            label="R$ RECEBER"
                                            value={NumberFormat.Currency(valorReceber || 0)}
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <label>Valor Recebido</label>
                                        <MaskedInput
                                            fluid
                                            mask="currency"
                                            label={"R$"}
                                            placeholder="Valor recebido"
                                            value={valorRecebido.replace("R$", "") || 0}
                                            onChange={handleOnChangeValorRecebido}
                                            action={{ icon: "check", color: "green", onClick: handleValores }}
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <Form.Input
                                            fluid
                                            readOnly
                                            label="R$ DÉBITO"
                                            value={NumberFormat.Currency(valorDebito * -1)}
                                            action={<ModalApp
                                                open={open}
                                                handleOpen={handleOpen}
                                                handleClose={handleClose}
                                                title={`Kit: ${state.numero}`}
                                                content={valorReajustado}
                                                trigger={{
                                                    floated: "right",
                                                    icon: "percent",
                                                    color: "red"
                                                }}
                                                onSuccess={{ content: "Salvar", func: handleValorCorrigido }}
                                            />}
                                        />
                                    </Form.Field>
                                </Form.Group>
                            </Form>
                        </Segment>
                    </Grid.Column>
                </Grid.Row>
            }
            {/*             
            CRIAR MODAL PARA DEFINIR VALOR CORRIGIDO
            TESTAR VALOR DE DÉBITO NO GERENCIAMENTO DE KIT            
            */}
            <Grid.Column>
                <Grid.Row>
                    <TableApp
                        render={tableRender}
                        list={tableList}
                        actions={(data: IItemModel, index: number) => {
                            if (!data.isNew) {
                                return ([
                                    <ModalYesNo
                                        trigger={<Button disabled={isDisabled || !isAlterable} icon="trash" color="red" />}
                                        header="Apagar"
                                        content="Deseja realmente apagar este item?"
                                        onSuccess={() => { removeItemKit(data.id || "") }}
                                    />
                                ]);
                            } else {
                                return [removeButton(index, data.isNew)]
                            }
                        }}
                        loading={false}
                    />
                </Grid.Row>
            </Grid.Column>
        </Grid>
    );

    return (
        <TemplateMain
            loading={loading}
            content={content}
        />
    );
};

export default GerenciarKit;
